document.querySelectorAll('.product-faqs').forEach((faq) => {
	faq.querySelectorAll('.product-faqs__question').forEach((button) => {
		button.addEventListener('click', function () {
			const currentWrapper = this.nextElementSibling;
			const openWrappers = faq.querySelectorAll('.animation-wrapper.is-open');

			// If the current FAQ item is already open, close it and return
			if (currentWrapper.classList.contains('is-open')) {
				currentWrapper.classList.remove('is-open');
				currentWrapper.style.maxHeight = '1px';
				button.classList.remove('is-open');
				return;
			}

			// Otherwise, close all other open FAQ items
			faq.querySelectorAll('.product-faqs__question').forEach((otherButton) => {
				otherButton.classList.remove('is-open');
			});
			openWrappers.forEach((wrapper) => {
				if (wrapper !== currentWrapper) {
					wrapper.classList.remove('is-open');
					wrapper.style.maxHeight = '1px';
				}
			});

			// And open the clicked FAQ item
			currentWrapper.classList.add('is-open');
			currentWrapper.style.maxHeight = currentWrapper.scrollHeight + 20 + 'px';
			button.classList.add('is-open');
		});

		button.addEventListener('keydown', function (e) {
			if (e.key === 'Enter' || e.key === ' ') {
				const currentWrapper = this.nextElementSibling;
				const openWrappers = faq.querySelectorAll('.animation-wrapper.is-open');
				faq.querySelectorAll('.product-faqs__question').forEach((otherButton) => {
					otherButton.classList.remove('is-open');
				});
				openWrappers.forEach((wrapper) => {
					if (wrapper !== currentWrapper) {
						wrapper.classList.remove('is-open');
						wrapper.style.maxHeight = '1px';
					}
				});
				currentWrapper.classList.toggle('is-open');
				this.classList.add('is-open');
			}
		});
	});
});
